import type { ChangeEvent, FC, FormEvent } from 'react';

import Button from '@/common-components/Button';
import FormField from '@/common-components/FormField';
import Input from '@/common-components/Input';

interface TwoFactorFormProps {
  email: string;
  code: string;
  codeError: string | null;
  submitError: string | null;
  isSubmitting: boolean;
  onChangeCode: (event: ChangeEvent<HTMLInputElement>) => void;
  onSubmit: (event: FormEvent<HTMLFormElement>) => void;
  onBack: () => void;
}

const TwoFactorForm: FC<TwoFactorFormProps> = ({
  email,
  code,
  codeError,
  submitError,
  isSubmitting,
  onChangeCode,
  onSubmit,
  onBack,
}) => (
  <form onSubmit={onSubmit} className="flex flex-col gap-4" noValidate>
    <p className="text-sm text-[var(--color-ink-muted)]">
      We emailed a 6-digit code to <span className="font-medium text-[var(--color-ink)]">{email}</span>.
      It expires in 10 minutes.
    </p>

    <FormField label="Verification code" htmlFor="login-2fa-code" error={codeError ?? undefined}>
      <Input
        id="login-2fa-code"
        type="text"
        inputMode="numeric"
        autoComplete="one-time-code"
        autoFocus
        value={code}
        onChange={onChangeCode}
        hasError={Boolean(codeError)}
        placeholder="000000"
      />
    </FormField>

    {submitError ? (
      <p
        role="alert"
        className="rounded-md border border-[var(--color-danger)]/30 bg-[var(--color-danger-bg)] p-3 text-sm text-[var(--color-danger-ink)]"
      >
        {submitError}
      </p>
    ) : null}

    <Button type="submit" loading={isSubmitting} size="lg" className="mt-2">
      Verify and sign in
    </Button>

    <button
      type="button"
      onClick={onBack}
      className="text-sm text-[var(--color-ink-muted)] underline-offset-2 hover:underline"
    >
      Back to sign in
    </button>
  </form>
);

export default TwoFactorForm;
